import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, buttonStyle, marginBottom } from '../../../helpers/getEmailStyles';

class ConfirmEmail extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      token: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  };

  render() {
    const { content: { token, email, name, logo, siteName } } = this.props;
    let verificationURL = url + `/user/verification?confirm=${token}&email=${email}`;
    let firstName = name.charAt(0).toUpperCase() + name.slice(1);

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Hi {firstName},
          </div>
          <EmptySpace height={20} />
          <div style={marginBottom}>
            Welcome to {siteName}! We're excited to have you on board.
          </div>
          <div>
            Ready to get started? Just verify your email address to complete your setup.
          </div>
          <EmptySpace height={40} />
          <div>
            <a style={buttonStyle} href={verificationURL}>Confirm your email</a>
          </div>
          <EmptySpace height={30} />
          <EmailSignature siteName={siteName} />
        </div>
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default ConfirmEmail;